<template>
  <v-row no-gutters class="secondary-card pa-3">
    <v-col cols="12" class="text-left">
      <div class="subtitle-2">
        <v-skeleton-loader
            width="100"
            height="22"
            type="text"
        ></v-skeleton-loader>
      </div>
    </v-col>
    <v-col cols="12">
      <div class="skeletons">
        <div class="skeleton-item" v-for="(skel, i) in skeletons" :key="i">
          <v-skeleton-loader
              loading
              width="100%"
              :height="78"
              type="list-item-avatar"
          ></v-skeleton-loader>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ClientAttentionSkeleton",
  props: {
    skeletonsQty: {
      type: Number,
      default: 3
    }
  },

  computed:{
    skeletons(){
      const vm = this
      return [...Array(vm.skeletonsQty).keys()]
    }
  }

}
</script>

<style scoped >

  .skeletons {
    display: inline-block;
    width: 100%;
    padding: 5px;
    text-align: left;
    min-height: 80px;
    overflow-x: hidden;
    overflow-y: visible;
    white-space: nowrap;
  }

  .skeleton-item {
    background-color: var(--v-components-base);
    display: inline-block;
    width: 280px !important;
    margin: 5px 4px 15px 4px;
  }

  .subtitle-2 {
    height: 22px;
  }


</style>
